"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const react_2 = require("@osmosys/react");
exports.OsmosysResourceCard = ({ children, }) => {
    return (react_1.default.createElement(reactstrap_1.Card, null,
        react_1.default.createElement(reactstrap_1.CardBody, null,
            react_1.default.createElement(react_2.OsmosysDiv, { flexCol: true }, children))));
};
//# sourceMappingURL=OsmosysResourceCard.js.map